export default function (communicator) {

  return (target) => {

    const provider = target.prototype || target

    const type = target.storeName

    if (type === 'ReviewStore') {
      provider.handleComment = function handleComment(data) {
        if (!data) {
          return
        }
        this.addTempComment(data)
      }
    }

    if (type === 'ApplicationStore') {
      provider.handlePageUpdated = function handlePageUpdated(data) {
        if (!data) {
          return
        }
        this.flagPageChanged(data)
      }
    }

    provider.initCommunicator = function initCommunicator() {

      communicator.watch('comment', (data) => {
        if (this.handleComment) {
          this.handleComment(data)
        }
      })
      communicator.watch('message', (data) => {
        if (this.handleComment) {
          this.handleComment(data)
        }
      })
      communicator.watch('pageUpdated', (data) => {
        if (this.handlePageUpdated) {
          this.handlePageUpdated(data)
        }
      })
    }
  }
}


export const chatable = (target) => {
  const provider = target.prototype

  provider.initChatable = function initChatable() {
    this.testState = false
  }
}
